import { Component, OnInit } from '@angular/core';
import { ModalExtended} from 'ngx-dynamic-modal';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {VnaCampaignService} from '../../services/vna-campaign.service';
import {AlertaService} from '../../../../../shared/services/alerta.service';
import {AuthService} from '../../../../../core/service/auth.service';

import * as _ from 'underscore';

@Component({
  selector: 'app-vna-campaign-create',
  templateUrl: './vna-campaign-create.component.html',
  styleUrls: ['./vna-campaign-create.component.scss']
})
export class VnaCampaignCreateComponent extends  ModalExtended implements OnInit {

    formData:FormGroup;
    data:any;
    portal:any;
    enabled:boolean;
    config_service={ config:{},auth:{} };

    submitted: boolean = false;

  constructor(private campHandler:VnaCampaignService, private alerta:AlertaService, private auth: AuthService) {
    super();
    this.formData=new FormGroup(
        {
            'service_pk' :new FormControl('',Validators.required),
            'client_pk' :new FormControl('',Validators.required),
            'name' :new FormControl('',Validators.required),
            'active' :new FormControl('0',Validators.required),
            'type' :new FormControl('TIME',Validators.required),
            'internal' : new FormControl('0', Validators.required),
            'is_verification' : new FormControl('0')
        }
    )
  }

  ngOnInit() {
      if(!_.isEmpty(this.data)){
          this.formData.controls['service_pk'].setValue(this.data['service_pk']);
          this.formData.controls['client_pk'].setValue(this.data['client_pk']);
          this.formData.controls['name'].setValue(this.data['name']);
          this.formData.controls['active'].setValue(this.data['active']);
          this.formData.controls['type'].setValue(this.data['type']);
          this.formData.controls['internal'].setValue((this.data['internal_camp'] == '1') ? '1' : '0');
          this.formData.controls['is_verification'].setValue((this.data['verification_camp'] == '1') ? '1' : '0');
      }
  }

  isEmptyData(){
      return _.isEmpty(this.data);
  }

  onExit(data){
      this.applyCallback(data);
      this.close();
  }

  createCamp(){

      if(!this.formData.valid){
          this.submitted = true;
          return;
      }

      this.enabled=true;
      let data=Object.assign({}, this.formData.value, {'portal_pk' : this.auth.getPkPortal()});

      data['config_service']=this.config_service;
      this.campHandler.createCampaign(data)
          .subscribe(result=>{
              if(result.hasOwnProperty('error')){
                  this.alerta.addAlert('warning',result['error']);
                  this.onExit(false);
                  return;
              }
              this.alerta.addAlert('success','Campaign Created succesfully!!');
              this.onExit(result)
          },error=>{
              console.log(error);
              this.alerta.addAlert('error','Something Went Wrong!!');
          },()=>{
              this.enabled=false;
          })

  }

  updateCamp(){

      if(!this.formData.valid){
          this.submitted = true;
          return;
      }

      this.enabled = true;
      let data=Object.assign({}, this.formData.value, {'portal_pk' : this.auth.getPkPortal()});

      this
          .campHandler
          .updateCampaign(this.data['pk_camp'], data)
          .subscribe(result=>{
              this.alerta.addAlert('success','Campaign updated succesfully');
              this.onExit(result)
          },error=>{
              this.alerta.addAlert('error','Something Went Wrong!!');
          },()=>{
              this.enabled=false;
          })
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/modals/vna-campaign-create/vna-campaign-create.component.ts